import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import RestaurantHeader from "./RestaurantHeader";
import { ReactComponent as PlusIcon } from "../assets/images/add_plus.svg";

const RestaurantHeaderWithAddBtn = ({ title, onBackBtnClick, showTitleOnly, containerSX, btnText, btnIcon = null, btnStyle, onBtnClick = null }) => {
    return (
        <Box sx={{ ...styles.titleMainBox, ...containerSX }}>
            <RestaurantHeader
                title={title}
                onBackBtnClick={onBackBtnClick}
                showTitleOnly={showTitleOnly}
            />
            {btnText && <Button onClick={onBtnClick}
                sx={{ backgroundColor: 'black', color: 'white', px: 1, '&:hover': { backgroundColor: 'black' }, ...btnStyle }}>
                {btnIcon ?? <PlusIcon />}&nbsp;{btnText}
            </Button>}
        </Box>
    )
}

export default RestaurantHeaderWithAddBtn;

const styles = {
    titleMainBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
}
